import api from '../../../services/Api';
import { IAuditoriaAdiantamentoClientesResultado } from '../interfaces/IAuditoriaAdiantamentoClientes';

export const AuditoriaAdiantamentoClientesService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaAdiantamentoClientesResultado> {
    const response = await api.get<IAuditoriaAdiantamentoClientesResultado>('auditoria-adiantamento-clientes/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoEstagnacao: '',
        adiantamentosEstagnados: [],
        adiantamentosConciliados: [],
      }
    );
  },
};
